const PRICE_SOURCE = {
  none: "None",
  gold: "Gold"
};

export default PRICE_SOURCE;
